import React from 'react';
import DefinitionGameCard from '../components/games/DefinitionGame/GameCard';
import FlashcardGameCard from '../components/games/FlashcardGame/GameCard';

const StudyPage = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-semibold">Nauka</h1>
        <p className="text-sm text-neutral-500">Wybierz jedną z dostępnych gier, aby rozpocząć naukę</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <FlashcardGameCard />
        <DefinitionGameCard />
      </div>
    </div>
  );
};

export default StudyPage; 